import { ThunkDispatch } from '@reduxjs/toolkit';
import { Component, memo } from 'react';
import QuestionViewer from '../QuestionViewer';
import MultipleAnswerFieldsEditor, {
  MultipleAnswerFieldsViewer,
} from './MultipleAnswerFields';
import {
  IMultipleAnswerField,
  IMultipleAnswerQuestionView,
  QuestionState,
} from 'store/survey/surveyTypes';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';

interface IComponentProp extends IQuestionViewerProp {
  dispatch: ThunkDispatch<any, never, any>;
  question: { data: IMultipleAnswerQuestionView; state: QuestionState };
}

interface IComponentState {
  maxAnswers: null | number;
  questionFields: IMultipleAnswerField[];
}

class MultipleAnswerQuestionViewer extends Component<
  IComponentProp,
  IComponentState
> {
  constructor(props: IComponentProp) {
    super(props);
    const { maxAnswers, questionFields } = props.question.data;
    this.state = {
      maxAnswers: maxAnswers || null,
      questionFields,
    };
  }

  render() {
    const {
      tags,
      index,
      dispatch,
      surveyId,
      question,
      displayDeleted,
      providerSurvey,
      readOnly,
      ...otherProps
    } = this.props;
    return (
      <QuestionViewer
        icon="menu"
        tags={tags}
        index={index}
        surveyId={surveyId}
        question={question}
        dispatch={dispatch}
        providerSurvey={providerSurvey}
        displayDeleted={displayDeleted}
        readOnly={readOnly}
        child={(editing: boolean) =>
          !editing ? (
            <MultipleAnswerFieldsViewer />
          ) : (
            <MultipleAnswerFieldsEditor />
          )
        }
        {...otherProps}
      />
    );
  }
}

export default memo(
  MultipleAnswerQuestionViewer,
  (prevProps: IComponentProp, nextProps: IComponentProp) => {
    return (
      prevProps.question === nextProps.question &&
      prevProps.index === nextProps.index &&
      prevProps.questionState === nextProps.questionState
    );
  }
);
